export const data = [
    {
        id: 1,
        name: '原岩 南港店',
        area: 'north',
        location: '南港',
        weekday_open_time: '平日 12:00-23:00',
        weekend_open_time: '假日 9:00-21:00',
        weekday_price: '平日全天 NT$450, 下午 NT$320(12-18), 晚上 NT$400(18-23)',
        weekend_price: '假日全天 NT$450',
        night_ticket: '平日星光 NT$300(20:30-23), 假日星光 NT$300(18:30-21)',
        student_ticket: '平日全天 NT$450, 平日下午 NT$250(12-18), 平日晚上 NT$300(17-23)',
        kid_ticket: '兒童 NT$250, 幼兒 NT$200',
        rental: '岩鞋 NT$100, 粉袋 NT$80',
        type: '抱石',
        membership: '非強制入會',
        trial_course: '',
        image: 'tup_nangang.png',
        googlemaps: 'https://goo.gl/maps/YXX93cPg8akzfmc4A',
        web: '',
    },
    {
        id: 2,
        name: '原岩 萬華店',
        area: 'north',
        location: '萬華',
        weekday_open_time: '平日 10:00-23:00',
        weekend_open_time: '假日 9:00-21:00',
        weekday_price: '平日全天 NT$450, 早鳥 NT$250(10-13), 下午 NT$320(12-18), 晚上 NT$400(17-23)',
        weekend_price: '假日全天 NT$450',
        night_ticket: '平日星光 NT$300(20:30-23), 假日星光 NT$250(18:30-21)',
        student_ticket: '平日全天 NT$350, 早鳥 NT$200(10-13), 下午 NT$250(12-18), 晚上 NT$300(17-23)',
        kid_ticket: '兒童 NT$250, 幼兒 NT$200',
        rental: '岩鞋 NT$100, 粉袋 NT$80',
        type: '抱石',
        membership: '非強制入會',
        trial_course: '750/人 40分鐘',
        image: 'tup_wanhua.png',
        googlemaps: 'https://goo.gl/maps/YXX93cPg8akzfmc4A',
        web: 'https://www.tupclimbing.tw/zh/wanhua_rate',
    },
    {
        id: 3,
        name: 'MegaSTONE',
        area: 'north',
        location: '新莊',
        weekday_open_time: '10:00-23:00',
        weekend_open_time: '9:00-21:00',
        weekday_price: '平日 NT$360',
        weekend_price: '假日 NT$400',
        night_ticket: '平日星光 NT$300(20:30-23), 假日星光 NT$250(18:30-21)',
        student_ticket: '平日 NT$250, 假日 NT$300',
        kid_ticket: '平日 NT$180, 假日 NT$190',
        rental: '-',
        type: '抱石, 上攀',
        membership: '非強制入會',
        trial_course: '抱石體驗, 上攀體驗, 抱石+上攀體驗',
        image: 'megastone.png',
        googlemaps: 'https://goo.gl/maps/YXX93cPg8akzfmc4A',
    },
    {
        id: 4,
        name: 'POGO',
        area: 'north',
        location: '新莊',
        weekday_open_time: '10:00-23:00',
        weekend_open_time: '9:00-21:00',
        weekday_price: '平日 NT$360',
        weekend_price: '假日 NT$360',
        night_ticket: 'NT$200(20:30-23)',
        student_ticket: 'NT$300',
        kid_ticket: '平日 NT$180, 假日 NT$190',
        rental: '-',
        type: '抱石',
        membership: '非強制入會',
        trial_course: '單人$750、2人$600/人、3~6人$500/人',
        image: 'pogo.png',
        googlemaps: 'https://goo.gl/maps/YXX93cPg8akzfmc4A',
    },

];

/*
"位置" location
"營業時間" open_time
"價格" price
"星光票" night_ticket
"裝備租借" rental
"類型" type
"會員制度" membership
"體驗課程" trial_course
*/